// conductor-mcp · conductor b6837825 (main) · origin: dev-mcp · domain: moms · body c6eaa025e5e9
// generated by pbo-conductor — 합배송스케쥴 (ma19)
// conductor-build: b683782 2026-11-03T04:23:13.900Z · pbo-core 0.8.7
// dev 위치: pages/master/pairOrderSchedule
// 데이터 seam: useGetPairOrderScheduleList — TODO(dev): 목데이터를 이 훅으로 교체
//
// 그룹 규격 — 이 화면이 쓰는 공통 조합의 계약(컨덕터 소유).
//   이 값을 벗어나면 컨덕터 데모와 어긋납니다. 규격을 바꾸려면 컨덕터에서 바꾸세요.
//   ⚠️ 그룹은 화면마다 사본으로 나갑니다 — 여기서 고쳐도 다른 화면은 바뀌지 않습니다.
//   titleRow #0d760c
//     · title(제목) — 자유 입력
//     · backRoute(뒤로가기 라우트) — 자유 입력
//     · notice(제목 옆 안내 문구) — 자유 입력
//     · stickyTop(스티키 멈춤 위치(px)) 제한 없음 [기본 12]
//     · buttonSize(타이틀 버튼 크기) = S | M | L [기본 L]
//     · 제목 옆 컨트롤과 우측 액션은 자리를 섞지 않는다 — 컨텍스트(센터·뷰)는 제목 옆, 행위는 우측 끝
//   filterCard #e70a16
//     · platform(배치 규약(desktop 라벨 위·3~4열 / moss 라벨 왼쪽·항상 3열)) = desktop | moss [기본 desktop]
//     · searchText(조회 버튼 문구) — 자유 입력
//     · resetText(초기화 버튼 문구) — 자유 입력
//     · defaultCollapsed(진입 시 접힘) = 켬 | 끔 [기본 false]
//     · summaryMessage(요약 카드 아래 안내 문구(summary 슬롯 있을 때)) — 자유 입력
//     · cols(한 줄 항목 수(moss)) 3~3개
//     · colGap(항목 가로 간격(moss)) 제한 없음
//     · rowGap(줄 세로 간격(moss)) 제한 없음
//     · labelWidth(라벨 칸 고정폭(moss)) 제한 없음
//     · labelGap(라벨-값 간격(moss)) 제한 없음
//     · itemMaxWidth(필터 항목 최대 폭) ≤ 420px [기본 420px]
//     · itemsPerRow(한 줄 항목 수) 3~4개 [기본 4개]
//     · collapsedShows(접었을 때 노출) = 값이 있는 항목만 | 전부 [기본 값이 있는 항목만]
//     · twoColBreakpoint(2단 필드 칩 접힘 폭) 제한 없음 [기본 320px]
//     · valueMinWidth(값 컨트롤 최소 폭) 제한 없음 [기본 240px]
//     · typeMinWidth(유형 셀렉트 최소 폭) 제한 없음 [기본 88px]
//     · typeMaxWidth(유형 셀렉트 최대 폭) 제한 없음 [기본 120px]
//     · 필터 항목 width는 max 420px 해상도에 따라 조절
//     · 한 줄에 필터 항목 3개부터 최대 4개까지 노출.
//     · 필터 접기 시, 값이 있는 필터만 노출
//     · 필터 접기 시, 값이 전부 없는 경우 문구 노출.
//   tableGroup #7b6f57
//     · pagerVariant(페이저 표기) = paged | range [기본 paged]
//     · pager(페이저 노출) = 켬 | 끔 [기본 true]
//     · listSearch(목록 검색 노출) = 켬 | 끔 [기본 true]
//     · pagerSizeChanger('몇개씩' 노출) = auto | hide [기본 auto]
//     · rightFirst(화면 우측 요소를 표준 앞에) = 켬 | 끔 [기본 false]
//     · leadColumns(선두 컬럼) = 체크박스 → No | No | 없음 [기본 체크박스 → No]
//     · checkboxWidth(체크박스 폭) 제한 없음 [기본 48px]
//     · noWidth(No 폭) 제한 없음 [기본 48px]
//     · 값·말줄임 짤림 금지 — 컬럼 폭은 콘텐츠 맞춤
//     · 엑셀 다운로드는 exportColumns(한글 헤더) 지정
//   uploadModal #92b032
//     · title(모달 제목) — 자유 입력
//
import { core, renderMarked } from '@musinsa/pbo-core'
import { pboLogisticsTheme } from '@musinsa/pbo-core/theme'
import '@musinsa/pbo-core/tokens.css'
import '@musinsa/pbo-core/styles.css'
import '@musinsa/pbo-core/fonts.css'
import './screenShell.css'
import { wiring } from './wiring'
import { type ComponentProps, type FC, type ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import dayjs, { type Dayjs } from 'dayjs'
import { Icon as DsIcon } from '@musinsa/pbo-assets'
import { clearTableUnsaved, confirmDiscardUnsaved, setTableUnsaved } from './unsavedGuard'
import { fillSelectionTokens } from './selectionTokens'
import { usePageHeaderSticky } from './pageHeaderSticky'
import type { ButtonCode, ToolbarConfig } from '@/services/auth/menu.types'
// 버튼 권한 슬롯(LOGISPRD-16733) — 슬롯이 없으면 전부 보이고 편집된다.
const permCan = (code: ButtonCode) => wiring.permission?.canShow(code) ?? true
const permTool = (key: keyof ToolbarConfig) => wiring.permission?.toolbar[key] ?? true
const permCols = (columns: core.CoreColumnType[]) => wiring.permission?.columns(columns) ?? columns

/** 배선 계약(문서 50) — wiring.ts(개발자 소유)가 이 타입을 채운다. 이름은 노드 id·상수명에서 기계적으로 나온다.
 *  화면(이 파일)은 재핸드오프 때 통째로 덮어쓴다 — 계약이 바뀌면 dev tsc 가 wiring.ts 의 그 자리를 가리킨다. */
export type Row = Record<string, unknown>
/** 표 슬롯 인자 — filters = 같은 화면 조회영역 값(키 = filterKey/노드 id) · pager = 액션바 페이저(page 1부터, size). 없는 화면은 undefined.
 *  모달 안 후보 표는 filters = 모달 [조회]가 적용한 조건(__applied: true 가 있으면 눌렀음, {} 이면 아직) · target = 그 모달을 연 셀(행·칸). */
export type RowsQuery = { filters?: Record<string, unknown>; pager?: { page: number; size: number }; target?: CellTarget; meta?: Record<string, unknown> } // meta = 모달 열림 페이로드(국가 등 — 한 모달을 여러 행이 공유할 때)
/** 액션 슬롯 인자 — selected = 같은 core.TableSelectionScope 안 표의 선택 행(체크박스). 선택 표가 없는 화면은 빈 배열. */
export type ActionCtx = { selected: Row[]; visible?: Row[]; form?: FormState; picked?: Row[]; target?: CellTarget; files?: MediaFile[]; value?: string; meta?: Record<string, unknown> } // selected = 체크 선택 행 · visible = 목록 검색 뒤 화면에 보이는 행(표가 여럿이면 마지막 표, 검색칸 없는 화면은 없음) · form = 확인을 누른 모달의 폼 값(폼 스토어가 있는 모달만) · value = Enter 로 확정한 입력 값(<입력>_enter 슬롯만)
/** 폼 버스 상태(모달·카드의 입력 값). 조건(hideWhen 등)은 wiring.form.<store> 가 덮어쓴 유효 상태를 본다. */
export type FormState = Record<string, unknown>
/** 선택지(옵션) — value 는 API/코드 값, label 은 표시 문구. 조회영역·모달 셀렉트/라디오는 숫자 value 도 쓴다. */
export type Option = { value: string | number; label: string }
/** 편집 셀 셀렉트의 선택지 — DS 셀 계약(variantProps.options)이 value 를 문자열로만 받는다. */
export type CellOption = { value: string; label: string }
/** 셀이 연 모달의 대상(2026-09-30) — rowKey = 그 행의 key(배열 인덱스 또는 배선이 실은 key) · dataIndex = 연 칸 · row = 그 행 · value = 미디어 셀 값(개수). 헬퍼·미디어 모달 슬롯의 ctx.target. */
export type CellTarget = { rowKey: string; dataIndex: string; row: Row; value?: unknown }
/** 미디어 모달 파일(DS core.MediaManager 계약 — 이름·썸네일뿐이라 서버 파일은 배선이 이름으로 잇는다). 헬퍼·미디어 모달 슬롯의 ctx.files. */
export type MediaFile = { name: string; thumb?: string }
/** 표 컬럼 배치(2026-10-21) — DS core.Table 의 제어형 prop 그대로. 컬럼 id = dataIndex(재핸드오프로 dataIndex 가 바뀌면 그 컬럼 저장값은 무시된다).
 *  순서·너비는 조절한 것만 와도 된다. 초기화는 []/{} (undefined 로 바꾸면 비제어로 돌아가 직전 내부 상태가 남는다). */
export type ColumnLayout = Pick<core.CoreTableProps, 'columnOrder' | 'onColumnOrderChange' | 'columnWidths' | 'onColumnWidthsChange' | 'pinnedColumns' | 'onPinnedColumnsChange' | 'hiddenColumns' | 'onHiddenColumnsChange'>
export type Wiring = {
  /** 표 데이터 — 인자는 데모 목데이터(자리 표시)와 조회 조건·페이저. 컴포넌트 본문 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅을 써도 된다.
   *  배열을 돌려주면 클라이언트 페이징(데모와 같음), { rows, total } 을 돌려주면 서버 페이징(표는 그대로 그리고 카운트·페이저는 total). */
  rows: { ROWS: (demo: Row[], q: RowsQuery) => Row[] | { rows: Row[]; total?: number; loading?: boolean } }
  /** 동작 — 조회(search)·버튼·확인창·모달 확인·편집 셀·행 버튼. 실패는 throw(확인창·모달이 열린 채 남는다). 성공 토스트·닫기는 생성본이 한다. */
  actions: { search: (filters: Record<string, unknown>) => void | false | Promise<void | false>; ma19AddButton: (ctx: ActionCtx & { table: string; defaults: Record<string, unknown> }) => void | string | false | Promise<void | string | false>; ROWS_rowsChange: (rows: Record<string, unknown>[]) => void; ma19RequiredNotice_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; ma19SaveConfirm_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; ma19DeleteConfirm_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; ma19DownloadModal_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; ma19UploadModal_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false> }
  /** 요청 진행 중 여부(React 훅) — true 면 선택 게이트 버튼(확정·삭제·저장 등)이 잠긴다. 선택 게이트 버튼이 매 렌더 부르므로 안에서 훅을 써도 된다(예: react-query useIsMutating() > 0). 없으면 잠그지 않는다. */
  useBusy?: () => boolean
  /** 액션 슬롯 실패 기록(슬롯 이름 · 원인) — 모니터링·토스트 등. 없으면 생성본이 다시 던져 미처리 거부로 올린다(콘솔엔 브라우저가 찍는다). */
  onActionError?: (slot: string, error: unknown) => void
  /** [초기화] 전 확인 — false(또는 false 로 풀리는 Promise)면 초기화하지 않는다(미저장 행 보호 확인창). 없으면 바로 초기화. */
  canReset?: () => boolean | Promise<boolean>
  /** 선택 비우기 신호 — 배선이 표를 새로 깔면(재조회 뒤) 이 값을 바꾼다(예: 조회 응답 식별자). 바뀔 때마다 체크 선택이 비워진다. */
  selResetToken?: unknown
  /** 조회 칸 필수 덮어쓰기(키 = 조회 조건 키) — 권한·서버 설정으로 필수가 풀리는 칸. 없으면 데모대로 필수. */
  filterRequired?: { "ma19ClsDate:filterFieldDef"?: boolean }
  /** 표 컬럼 가공(키 = 표 노드 id) — 플래그 열 추가·제목 치환 등 정의 자체를 바꾼다. 배치(순서·너비·고정·숨김)는 columnLayout. 메모돼 표 상태가 유지된다. */
  columns?: { ma19Table?: (columns: core.CoreColumnType[]) => core.CoreColumnType[] }
  /** 표 그룹 문구(키 = 표 그룹 노드 id) — 카운트 라벨("전체"→"조회" 등)·빈 표 문구. 없으면 데모 문구. */
  tableText?: { tableGroup?: { totalLabel?: string; emptyText?: string } }
  /** 표 위 안내 자리(키 = 표 그룹 노드 id) — 조회 결과 안내(건수 초과·경고)를 ReactNode 로. 없으면 비어 있다. */
  feedback?: { tableGroup?: ReactNode }
  /** 표 체크 선택이 바뀔 때 — 상세 표가 선택을 따라가는 화면(마스터-디테일)에서 배선이 그 키로 상세를 조회한다.
   *  선택이 있는 스코프만 알린다(위아래 표에서 빈 스코프가 덮지 않게). 액션 슬롯의 ctx.selected 와 같은 값이다.
   *  scope = **그 선택이 어느 표 그룹의 것인지**(그룹 노드 id). 위아래 표가 있는 화면은 이것으로 갈라 둔다 —
   *  선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지 알 수 없다(2026-09-21 est01). */
  onSelect?: (rows: Row[], scope: string) => void
  /** 업로드 성공 뒤 표의 **보이는 행을 체크**한다(옛 손코드가 업로드한 행을 바로 [저장] 하게 하던 동작). 없으면 종전대로 선택을 비운 채 둔다.
   *  true = 보이는 행 전부(rgr01·rgr10 과 같다) · 함수 = 보이는 행 중 true 를 준 행만(조회 결과 위에 업로드 행을 얹는 화면 — 조회 행까지 저장되지 않게).
   *  그 뒤 선택을 비우는 자리(조회·초기화·저장/확정 성공)에서는 같이 풀린다. */
  selectAllAfterUpload?: boolean | ((row: Row) => boolean)
  /** 페이지를 옮기기 **전** 물어본다 — false 를 주면 옮기지 않는다(미저장 편집 보호 등, 옛 손코드의 window.confirm 자리).
   *  확인 모달(core.Modal.confirm)로 물을 땐 Promise<boolean> 을 돌려준다 — 답이 true 로 오면 그때 옮긴다(false·거부면 그대로).
   *  onState 는 **이미 바뀐 뒤** 통지라 되돌릴 수 없다 — 막아야 하는 것은 여기서 막는다. 없으면 그냥 옮긴다. */
  canChangePage?: (next: { pager: string; page: number; size: number }) => boolean | Promise<boolean>
  /** [초기화] 직후 알림 — 생성본은 조회영역 입력값만 기본값으로 되돌린다. 목록(조회 결과)·페이지·표 선택·목록 검색어는 그대로다.
   *  화면 밖에 저장한 입력 조건(URL/세션 등)을 기본값으로 맞출 때만 쓴다. **조회 결과를 비우거나 재조회하지 않는다** — 목록은 [조회]로만 바뀐다(PD 결정 2026-10-21). 없으면 화면 값만. */
  onReset?: () => void
  /** 화면 상태(페이저·목록 검색어·상태 탭) 진입 초기값 — 동기 함수 아님, 값(예: URL 복원). 없으면 데모 기본값(1페이지·빈 검색어·기본 탭). */
  stateInitial?: { pager?: { "pager"?: { page?: number; size?: number } }; listq?: { "table.q"?: string } }
  /** 화면 상태가 바뀔 때(페이지 이동·검색어 확정·상태 탭 전환·조회 초기화) — 배선이 URL/세션에 싣는다(옛 손코드 page/keyword/tab persist). 상태 탭 값 = 탭 key('all' = 전체). */
  onState?: (s: { pager: { "pager": { page: number; size: number } }; listq: { "table.q": string } }) => void
  /** 모달 열기 전 가드 — 버튼 클릭 때 선택 행(ctx.selected)으로 부른다. false 를 돌려주면 열지 않는다(왜 못 여는지는 배선이 토스트로). 없으면 그냥 연다. */
  opens?: { ma19SaveButton?: (ctx: ActionCtx) => boolean; ma19DeleteButton?: (ctx: ActionCtx) => boolean; ma19UploadButton?: (ctx: ActionCtx) => boolean; ma19ExcelButton?: (ctx: ActionCtx) => boolean }
  /** 모달·드로어가 열리고 닫힐 때 — 열려 있는 동안에만 후보를 조회하는 게이트 자리(옛 손코드 `isXxxHelperOpen`).
   *  서치헬퍼 후보 API 는 무페이징 distinct 라 모달 밖에서 부르면 진입하자마자·타이핑마다 수십 MB 를 받는다
   *  (moms-fe #792 리뷰). 배선이 이 신호로 옛 게이트를 그대로 복원한다. 키 = 모달 노드 id. */
  onModal?: (open: { "ma19UploadModal": boolean; "ma19DownloadModal": boolean }) => void
  /** 옵션 — 조회영역 셀렉트·라디오·편집 셀 셀렉트의 선택지. 인자는 데모 옵션(자리 표시). 컴포넌트 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅(콤보 API 등)을 써도 된다.
   *  데모는 value=label 목데이터라, API 로 바꾸면(예: 화주 = 코드) 조회 조건·저장 값도 그 value 로 나간다 — 조회 기본값은 filterDefaults 로 같이 맞출 것.
   *  조회영역 옵션은 두 번째 인자로 **현재 조회영역 값**을 받는다(예: 화주유형 → 그 유형의 화주명만). */
  options?: { ROWS_IS_CURRENT?: (demo: CellOption[], meta?: Record<string, unknown>) => CellOption[]; REASONRADIO_OPTIONS?: (demo: Option[], filters?: Record<string, unknown>) => Option[] }
  /** 조회 조건 기본값 — 데모 기본값(예: 화주명 "무신사스탠다드")을 실값(예: 로그인 사용자 화주 코드)으로 덮어쓴다. **동기 함수**(훅 금지 — useMemo 안에서 한 번 계산). */
  filterDefaults?: { ma19FilterCard?: (demo: Record<string, unknown>) => Record<string, unknown> }
  /** 진입 초기값 — 기본값 위에 URL/세션 복원값을 얹는다(동기 함수). [초기화] 는 여기 값이 아니라 filterDefaults 로 돌아간다. */
  filterInitial?: { ma19FilterCard?: (defaults: Record<string, unknown>) => Record<string, unknown> }
  /** 늦게 오는 기본값 — 옵션(화주 목록 등)이 도착한 뒤 **비어 있는** 조회 조건을 채운다(예: 세션 화주가 없으면 첫 화주). 인자 = 현재 조회영역 값 · 조회영역 옵션들(슬롯명 = 키). 옵션 배열이 바뀔 때마다·[초기화] 뒤에 다시 부른다. 값이 있는 키는 덮지 않는다. 동기 함수. */
  filterFallback?: { ma19FilterCard?: (current: Record<string, unknown>, options: Record<string, Option[]>) => Record<string, unknown> | void }
  /** 표 컬럼 배치(2026-10-21, LOGISPRD-15649) — 사용자가 바꾼 순서·너비·고정·숨김을 배선이 저장·복원한다(예: 사용자·화주별 서버 저장).
   *  키 = 표 노드 id(재핸드오프로 표가 늘어도 밀리지 않는다). 함수 — 매 렌더 같은 자리에서 불리므로 안에서 저장 훅을 써도 된다.
   *  인자 columns = 그 표에 넘기는 컬럼 정의(정의 순서·기본 fixed) — 콜백은 바뀐 컬럼만 주므로 전체 상태 저장·고정 해제 복원에 쓴다.
   *  표에 따라 렌더마다 새 배열이다(본문 상수) — effect·memo 의존성에는 배열 대신 내용(dataIndex·fixed 목록)을 쓴다.
   *  없거나 그 표 키가 없으면 종전대로 표 내부 상태(저장 안 함). */
  columnLayout?: { "ma19Table"?: (columns: core.CoreColumnType[]) => ColumnLayout }
  /** 폼 버스 파생 필드 — 데모에서 스코프(화면 배선)가 채우던 값(예: 지난 날짜면 locked=true)을 입력 값(state)에서 계산해 덮어쓴다. 없으면 입력 값 그대로. */
  form?: { ma19DownloadModal?: (state: FormState) => FormState; ma19UploadModal?: (state: FormState) => FormState }
  /** 버튼 권한(LOGISPRD-16733) — 메뉴 API 의 버튼 권한 계산 결과. 없으면 전부 보이고 편집된다(지금 동작).
   *  canShow = code 가 붙은 버튼 노출 · toolbar = 엑셀 업로드·다운로드 등 툴바 버튼 · editable = false 면 [일괄 입력]을 숨긴다 ·
   *  columns = 표 컬럼(잠금이면 편집 셀을 글자로 바꿔 돌려준다 — 채우기·Delete·타이핑도 함께 막힌다). */
  permission?: { canShow: (code: ButtonCode) => boolean; toolbar: ToolbarConfig; editable: boolean; columns: (columns: core.CoreColumnType[]) => core.CoreColumnType[] }
}
/** 뷰가 받는 배선 — 아직 안 채운 슬롯이 있어도 된다(`<View wiring={{}} />` 도 뜬다). 다 채운 모습은 `Wiring`. */
export type WiringInput = Omit<Partial<Wiring>, 'rows' | 'actions'> & { rows?: Partial<Wiring['rows']>; actions?: Partial<Wiring['actions']> }

const renderPboEmpty = () => <core.Empty image={core.Empty.PRESENTED_IMAGE_SIMPLE} description="데이터 없음" />

// 액션 실패 기록 — 슬롯(wiring.ts)이 사용자 안내를 맡고, 생성본은 실패를 버리지 않고 원인과 함께 남긴다.
// 액션 실패 — 사용자 안내는 슬롯(wiring.ts)이 맡는다. 기록 슬롯(wiring.onActionError)이 있으면 거기로 넘기고, 없으면 다시 던져 미처리 거부로 올린다(원인을 버리지 않는다 · console 은 쓰지 않는다: dev no-console).
const reportActionError = (slot: string) => (e: unknown): void => { if (wiring.onActionError) { wiring.onActionError(slot, e); return } throw e }
// 조회 조건 기본값(데모) — 옵션을 API 로 바꾸면(예: 화주 = 코드) wiring.filterDefaults.ma19FilterCard 가 같은 키를 그 value 로 덮어쓴다(예: 로그인 사용자 화주 코드).
const flMa19FilterCardDefaults_DEMO: Record<string, unknown> = {}
const ROWS_IS_CURRENT_OPTIONS_DEMO: CellOption[] = [{"label":"Y","value":"Y"},{"label":"N","value":"N"}]
// TODO(api): ROWS 는 데모 목데이터 6행 중 앞 5행 — 실제 데이터로 교체(전체 표본은 패키지 data-requirements.json)
const ROWS_DEMO: Record<string, unknown>[] = [{"id":101,"SPR_NM":"MUSINSA","CLS_DATE":"20261102","CUT_SEQ":"","CUT_OFF_TIME":"","IS_CURRENT":"Y","FST_GI_END":"20261109","LST_GI_END":"","INS_DATE":"","INS_BY":"","UPD_DATE":"20261102074512","UPD_BY":"operator.a@example.com"},{"id":102,"SPR_NM":"","CLS_DATE":"20261103","CUT_SEQ":"","CUT_OFF_TIME":"","IS_CURRENT":"","FST_GI_END":"20261110","LST_GI_END":"","INS_DATE":"","INS_BY":"","UPD_DATE":"","UPD_BY":""},{"id":103,"SPR_NM":"","CLS_DATE":"20261104","CUT_SEQ":"1","CUT_OFF_TIME":"14","IS_CURRENT":"N","FST_GI_END":"20261111","LST_GI_END":"20261112","INS_DATE":"20261020101500","INS_BY":"operator.b@example.com","UPD_DATE":"20261021093000","UPD_BY":"operator.b@example.com"},{"id":104,"SPR_NM":"","CLS_DATE":"20261108","CUT_SEQ":"","CUT_OFF_TIME":"","IS_CURRENT":"","FST_GI_END":"20261114","LST_GI_END":"","INS_DATE":"","INS_BY":"","UPD_DATE":"","UPD_BY":""},{"id":105,"SPR_NM":"","CLS_DATE":"20261109","CUT_SEQ":"","CUT_OFF_TIME":"","IS_CURRENT":"","FST_GI_END":"20261116","LST_GI_END":"","INS_DATE":"","INS_BY":"","UPD_DATE":"","UPD_BY":""}]
// 걸러진 행 브리지 — 액션 슬롯 인자(ctx.visible). 목록 검색을 거친 뒤 화면에 보이는 행(표가 여럿이면 마지막 표).
const visRef: { current: Record<string, unknown>[] } = { current: [] }
const unsavedSave_ma19Table: { pick: (sel: Row[]) => Row[]; commit: (rows: Row[]) => void } = { pick: () => [], commit: () => {} } // [저장] 확인창(모듈 수준)이 요청 전 pick · 성공 뒤 commit — 컴포넌트가 effect 로 채우고 언마운트 때 비운다
// TODO(dev): 미저장 이탈 경고 — 메뉴 이동(LNB)은 라우터에서 막는다: 이동 전에 unsavedGuard.ts 의 confirmDiscardUnsaved(proceed) 를 부른다(react-router v5 = history.block). [조회]·[초기화]·새로고침은 생성본이 처리한다.
/** 확인창은 한 번에 하나 — 연타하면 확인창이 겹쳐 떠 요청이 그 수만큼 나간다(LOGISPRD-14894). 닫히면(확인 처리 뒤·취소) 다시 연다. 데모(ConfirmModalRender)와 같은 동작. */
let confirmOpen = false
const confirmOnce = (props: Parameters<typeof core.Modal.confirm>[0]) => {
  if (confirmOpen) return
  confirmOpen = true
  try {
    core.Modal.confirm({ ...props, afterClose: () => { confirmOpen = false; props.afterClose?.() } })
  } catch (e) {
    confirmOpen = false // 열지 못했으면 afterClose 도 안 온다 — 잠금을 남기지 않는다
    throw e
  }
}
const confirmma19RequiredNotice = (only?: Record<string, unknown>[]) => {
  selOnly.current = only ?? null
  return confirmOnce({
    afterClose: () => { selOnly.current = null },
    icon: <span style={{ display: 'inline-flex', lineHeight: 0, marginInlineEnd: 12 }}><DsIcon name="ic-alertCircle" size={22} color="#faad14" filled /></span>,
    title: "필수 항목 미입력",
    content: "화주코드·결제일을 입력하지 않은 행이 있습니다. 빨간 칸을 채운 뒤 다시 저장해 주세요.",
    okText: "확인",
    cancelText: "취소",
    okButtonProps: { danger: true },
    onOk: async () => {
      const okRes = await wiring.actions?.ma19RequiredNotice_ok?.(selCtx())
      if (typeof okRes === 'string') core.message.success(okRes)
    },
  })
}
const confirmma19SaveConfirm = (only?: Record<string, unknown>[]) => {
  selOnly.current = only ?? null
  return confirmOnce({
    afterClose: () => { selOnly.current = null },
    icon: <span style={{ display: 'inline-flex', lineHeight: 0, marginInlineEnd: 12 }}><DsIcon name="ic-alertCircle" size={22} color="#faad14" filled /></span>,
    title: "알림",
    content: fillTok("선택한 {count}건의 합배송스케쥴을 저장하시겠습니까?"),
    okText: "확인",
    cancelText: "취소",
    onOk: async () => {
      const okMsg = fillTok("{count}건 저장 완료")
      const okRes = await wiring.actions?.ma19SaveConfirm_ok?.(selCtx())
      if (okRes !== false) core.message.success(typeof okRes === 'string' ? okRes : okMsg)
      selReset.current()
    },
  })
}
const confirmma19DeleteConfirm = (only?: Record<string, unknown>[]) => {
  selOnly.current = only ?? null
  return confirmOnce({
    afterClose: () => { selOnly.current = null },
    icon: <span style={{ display: 'inline-flex', lineHeight: 0, marginInlineEnd: 12 }}><DsIcon name="ic-alertCircle" size={22} color="#faad14" filled /></span>,
    title: "알림",
    content: fillTok("선택한 {count}건의 합배송스케쥴을 삭제하시겠습니까? 삭제한 행은 복구할 수 없습니다."),
    okText: "삭제",
    cancelText: "취소",
    okButtonProps: { danger: true },
    onOk: async () => {
      const okMsg = fillTok("{count}건 삭제 완료")
      const okRes = await wiring.actions?.ma19DeleteConfirm_ok?.(selCtx())
      if (okRes !== false) core.message.success(typeof okRes === 'string' ? okRes : okMsg)
      selReset.current()
    },
  })
}
const REASONRADIO_OPTIONS_DEMO: Option[] = [{"value":"업무활용","label":"업무활용"},{"value":"고객요청","label":"고객요청"},{"value":"데이터 검증","label":"데이터 검증"},{"value":"기타","label":"기타"}]
// 확인 버튼 비활성 사유 툴팁(okDisabledTooltip) — 비활성일 때만 DS 툴팁으로 감싼다. extra = 푸터 좌측 보조 액션(footerExtra).
const withOkTip = (tip: string | null, extra?: ReactNode) => (_: ReactNode, { OkBtn, CancelBtn }: { OkBtn: FC; CancelBtn: FC }) => (
  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, alignItems: 'center' }}>
    {extra ? <div style={{ display: 'flex', gap: 8, marginRight: 'auto' }}>{extra}</div> : null}
    <CancelBtn />
    {tip ? (
      <core.Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tip}</span>}>
        <span>
          <OkBtn />
        </span>
      </core.Tooltip>
    ) : (
      <OkBtn />
    )}
  </div>
)
// 선택 행 브리지 — 액션 슬롯 인자(ctx.selected). 같은 core.TableSelectionScope 안 표의 체크 선택 행(SelBridge 가 채운다). 한 화면에 스코프가 여럿이면 마지막으로 바뀐 스코프의 선택이다.
const selRef: { current: Record<string, unknown>[] } = { current: [] }
// 확인창·모달이 **선택 중 일부만** 대상으로 열릴 때(예: 일괄 입고취소 — 취소 가능한 건만) 그 부분집합. null 이면 선택 전체.
//  문구 토큰({count})과 슬롯 인자(ctx.selected)가 같은 집합을 봐야 한다 — 데모 어댑터가 cancellable 건수를 세어 문구에 넣는 것과 같은 값.
const selOnly: { current: Record<string, unknown>[] | null } = { current: null }
// 확인창(모듈 함수) 성공 뒤 표 선택 비우기 — 컴포넌트가 마운트 동안 setter 를 꽂는다(스코프가 없으면 no-op)
const selReset: { current: () => void } = { current: () => {} }
const selCtx = (): ActionCtx => ({ selected: selOnly.current ?? selRef.current, visible: visRef.current })
// 문구 토큰 — {count} = 표 선택 수(호출 시점) · {<컬럼>} = 선택 행의 그 컬럼 값. 치환식은 동반 파일 selectionTokens.ts(데모와 같은 파일).
//  값은 **원본 행**(origRows = wiring.rows 가 준 행, 편집 셀 반영 전)에서 읽는다 — 편집만 하고 저장 안 한 값이 확인 문구에 보이면 실제 삭제·확정 대상(원본 식별자)과 어긋난다.
const origRows = new Map<string, Record<string, unknown>[]>()
const fillTok = (s: string): string => {
  const all = Array.from(origRows.values()).flat()
  const rows = (selOnly.current ?? selRef.current).map((r) => all.find((o) => o.key === r.key) ?? r)
  return fillSelectionTokens(s, rows.length, rows)
}

const POPUP_DOWN = {
  bottomLeft: { points: ['tl', 'bl'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
  bottomRight: { points: ['tr', 'br'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
}

const filterFieldClass = (key: string): string => `pbo-ff--${key.replace(/[^A-Za-z0-9_-]/g, '_')}`
const FILTER_FOCUSABLE = 'input:not([type=hidden]):not([disabled]), textarea:not([disabled]), [contenteditable=true], button:not([disabled])'
const FILTER_OPEN_EVENTS = ['pointerdown', 'mousedown', 'mouseup', 'click'] as const
const openFilterField = (open: () => void, key: string) => {
  open()
  window.setTimeout(() => {
    const frame = document.querySelector(`.${filterFieldClass(key)}`)
    if (!frame) return
    frame.querySelector<HTMLElement>(FILTER_FOCUSABLE)?.focus()
    // 고른 항목을 바로 고칠 수 있게 목록·달력까지 펼친다 — antd 는 포커스만으로 열지 않는다(셀렉트=selector, 날짜=입력이 받는다).
    const host = frame.querySelector<HTMLElement>('.ant-select-selector') ?? frame.querySelector<HTMLElement>('.ant-picker input')
    if (!host) return
    // forEach — dev 레포 ESLint(no-restricted-syntax)가 for…of 를 막는다(2026-09-19 dry 실측).
    FILTER_OPEN_EVENTS.forEach((type) => host.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window })))
  }, 0)
}

const chipRange = (v: unknown, fmt = 'YY-MM-DD'): string | null => (Array.isArray(v) && v[0] && v[1] ? `${dayjs(String(v[0])).format(fmt)} ~ ${dayjs(String(v[1])).format(fmt)}` : null)

/** 기본 기간 프리셋 → ['YYYY-MM-DD','YYYY-MM-DD']. periodBase 'futureTo' = 오늘~+N(입고예정일 등) / 'pastTo' = -N~오늘. */
const presetRange = (preset?: string, periodBase: 'futureTo' | 'pastTo' = 'futureTo'): [string, string] | undefined => {
  if (!preset) return undefined
  const now = dayjs()
  const n = preset === 'today' ? [0, 'day'] : preset === 'week' ? [6, 'day'] : preset === 'month' ? [1, 'month'] : preset === 'month3' ? [3, 'month'] : preset === 'month6' ? [6, 'month'] : null
  if (!n) return undefined
  const other = periodBase === 'futureTo' ? now.add(n[0] as number, n[1] as 'day' | 'month') : now.subtract(n[0] as number, n[1] as 'day' | 'month')
  const [a, b] = periodBase === 'futureTo' ? [now, other] : [other, now]
  return [a.format('YYYY-MM-DD'), b.format('YYYY-MM-DD')]
}

const toDayjsPair = (v: unknown): [Dayjs, Dayjs] | null => (Array.isArray(v) && v[0] && v[1] ? [dayjs(String(v[0])), dayjs(String(v[1]))] : null)

/** 조회영역 필드 프레임(그룹 cmp.FilterField) — 접힘이면 값 칩(값 없으면 숨김), 열림이면 DS FormItem(라벨 위). 규격 = pbo-core filter-layout.css .pbo-filter-field */
function FilterField({ collapsed, label, required, tooltip, width, chip, fieldKey, onOpen, children }: { collapsed: boolean; label?: string; required?: boolean; tooltip?: string; width?: number | string; chip?: string | null; fieldKey?: string; onOpen?: () => void; children?: ReactNode }) {
  if (collapsed) {
    // 칩을 누르면 조회영역이 열리고 그 항목으로 포커스가 간다(전 화면 공통).
    const open = fieldKey && onOpen ? () => openFilterField(onOpen, fieldKey) : undefined
    return (
      <div
        className="pbo-filter-closed"
        hidden={chip == null}
        {...(open
          ? {
              role: 'button',
              tabIndex: 0,
              style: { cursor: 'pointer' }, // 규격 CSS 는 칩을 읽기 전용으로 본다 — 누를 수 있다는 표시만 여기서
              onClick: open,
              onKeyDown: (e: { key: string; preventDefault: () => void }) => {
                if (e.key !== 'Enter' && e.key !== ' ') return
                e.preventDefault()
                open()
              },
            }
          : {})}
      >
        {label ? (
          <div className="pbo-filter-chip-label">
            <label>{label}</label>
            {required ? <span className="pbo-filter-req">*</span> : null}
          </div>
        ) : null}
        <div className="pbo-filter-chip-value">{chip}</div>
      </div>
    )
  }
  return (
    <core.FormItem className={fieldKey ? `pbo-filter-field ${filterFieldClass(fieldKey)}` : 'pbo-filter-field'} label={label} required={required} tooltip={!!tooltip} tooltipText={tooltip} labelPosition="top" boxedItem={false} style={width != null ? { width } : undefined}>
      {children}
    </core.FormItem>
  )
}

/** 기간 필드 — [기간유형 셀렉트 120 고정] + 레인지피커(프리셋 태그·'오늘/최근 N개월' 푸터·maxRangeDays·periodBase·좁으면 MM-DD). 값 = ['YYYY-MM-DD','YYYY-MM-DD']. */
function DateRangeField({ value, onChange, defaultPeriod, periodBase = 'futureTo', maxRangeDays, hidePresets, typeOptions, typeValue, onTypeChange, format = 'YY-MM-DD' }: { value?: [string, string]; onChange: (v: [string, string] | undefined) => void; defaultPeriod?: string; periodBase?: 'futureTo' | 'pastTo'; maxRangeDays?: number; hidePresets?: boolean; typeOptions?: Option[]; typeValue?: string | number; onTypeChange?: (v: string | number) => void; format?: string }) {
  const TAG: Record<string, string> = { today: '오늘', week: '일주일', month: '1개월', month3: '3개월', month6: '6개월' }
  const def = presetRange(defaultPeriod, periodBase)
  // 값이 비면(진입·초기화) 기본 기간으로 되돌려 보고한다 — 조회 조건에도 기본 기간이 걸린다.
  useEffect(() => {
    if (!value && def) onChange(def)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
  // 프리셋 태그는 **현재 값**에서 유도한다 — 조회영역을 접었다 펴면 이 컴포넌트가 리마운트되는데, 기본 프리셋으로 초기화하면
  //  실제 기간이 달라도 태그가 '오늘' 로 돌아간다(moms-fe #738 리뷰 2026-09-11). 값이 프리셋과 일치할 때만 태그를 단다.
  const tagOf = (v?: [string, string]): string | null => {
    if (!v) return (defaultPeriod && TAG[defaultPeriod]) ?? null
    const hit = Object.keys(TAG).find((k) => { const r = presetRange(k, periodBase); return !!r && r[0] === v[0] && r[1] === v[1] })
    return hit ? TAG[hit] : null
  }
  const [tag, setTag] = useState<string | null>(() => tagOf(value))
  const [selected, setSelected] = useState(0)
  const [open, setOpen] = useState(false)
  const [epoch, setEpoch] = useState(0)
  const [panel, setPanel] = useState<'date' | 'month' | 'year'>('date')
  const rootRef = useRef<HTMLDivElement>(null)
  const [compact, setCompact] = useState(false)
  useEffect(() => {
    const el = rootRef.current
    if (!el || !typeOptions?.length) return
    const ro = new ResizeObserver(() => setCompact(el.clientWidth > 0 && el.clientWidth < 260))
    ro.observe(el)
    return () => ro.disconnect()
  }, [typeOptions])
  const apply = (next: [Dayjs, Dayjs], label: string, months: number) => {
    onChange([next[0].format('YYYY-MM-DD'), next[1].format('YYYY-MM-DD')])
    setSelected(months)
    setTag(label)
    setOpen(false)
    setEpoch((e) => e + 1)
  }
  const picker = (
    <core.DatePicker.RangePicker placement="bottomLeft" {...({ builtinPlacements: POPUP_DOWN } as object)}
      key={`${epoch}-${compact ? 'c' : 'f'}`}
      className={typeOptions?.length ? 'pbo-filter-picker' : 'pbo-filter-picker pbo-filter-picker-full'}
      allowClear={false}
      format={compact ? 'MM-DD' : format}
      placeholder={['시작일', '종료일']}
      value={toDayjsPair(value ?? def)}
      open={open}
      onOpenChange={setOpen}
      onPanelChange={(_v, modes) => setPanel(((modes as string[]).find((x) => x !== 'date') as 'month' | 'year' | undefined) ?? 'date')}
      prefix={tag ? <core.Tag className="pbo-filter-date-tag" color="default" style={{ marginInlineEnd: 4 }}>{tag}</core.Tag> : undefined}
      onChange={(vals) => {
        setSelected(0)
        setTag(vals && vals[0] && vals[1] ? '직접' : null)
        onChange(vals && vals[0] && vals[1] ? [vals[0].format('YYYY-MM-DD'), vals[1].format('YYYY-MM-DD')] : undefined)
      }}
      disabledDate={(current, info) => {
        if (periodBase === 'pastTo' && current.isAfter(dayjs(), 'day')) return true
        if (maxRangeDays && info?.from && Math.abs(current.diff(info.from, 'days')) > maxRangeDays - 1) return true
        return false
      }}
      renderExtraFooter={
        hidePresets
          ? undefined
          : () => (
              <div className={`pbo-filter-date-footer ${panel}`}>
                <core.Button type="link" onClick={() => apply([dayjs(), dayjs()], '오늘', 0)}>
                  오늘
                </core.Button>
                <div className="pbo-filter-date-presets">
                  <span>{periodBase === 'pastTo' ? '최근' : '오늘부터'}</span>
                  {[1, 2, 3, 6].map((m) => (
                    <core.Button key={m} className={m === selected ? 'selected' : undefined} onClick={() => apply(periodBase === 'pastTo' ? [dayjs().subtract(m, 'month'), dayjs()] : [dayjs(), dayjs().add(m, 'month')], `${m}개월`, m)}>
                      {m}개월
                    </core.Button>
                  ))}
                </div>
              </div>
            )
      }
      style={{ width: '100%' }}
    />
  )
  if (!typeOptions?.length) return picker
  return (
    <div className="pbo-filter-date pbo-filter-row" ref={rootRef}>
      {/* 기준일 — onTypeChange 가 있으면(데모 typeFilterKey) 조회 조건에 싣는다. 없으면 종전대로 보이기만 한다. */}
      <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-type" options={typeOptions} {...(onTypeChange ? { value: typeValue ?? typeOptions[0]?.value, onChange: onTypeChange } : { defaultValue: typeOptions[0]?.value })} popupMatchSelectWidth={false} />
      {picker}
    </div>
  )
}

/** 요청 진행 중(선택 게이트 잠금) — wiring.useBusy 훅(없으면 항상 false). 훅이라 렌더마다 최신값이다(예: react-query useIsMutating) — 모듈 변수를 effect 에서 대입하면 한 렌더 늦게 보인다. */
const noBusy = (): boolean => false
/** 선택 0개면 비활성 — 같은 core.TableSelectionScope 안의 표 선택 개수를 읽는다(DS 훅). 스코프 밖이면 항상 비활성. 요청 중(useBusy)에도 잠긴다.
 *  exact = 선택이 정확히 그 개수일 때만 활성(단건 처리 버튼). useBusy 는 호출 때 읽는다(모듈 평가 때 잡아 두면 컴포넌트 모드의 홀더 갱신을 못 본다). */
function SelGatedButton({ disabled, exact, ...rest }: ComponentProps<typeof core.Button> & { exact?: number }) {
  const n = core.useTableSelectionCount() ?? 0
  const busy = (wiring.useBusy ?? noBusy)()
  return <core.Button {...rest} disabled={disabled || n === 0 || (exact != null && n !== exact) || busy} />
}

/**
 * 편집 시 자동 체크 표 — 셀을 고친 행을 체크 선택에 더한다(1.0 CommonUtil.onCellValueChanged 의 setSelected(true) 미러).
 * 같은 표 묶음의 [저장] 이 체크한 행만 보내는 화면에서, 고치고 체크를 잊어 저장이 꺼진 채 남거나 고친 행이 빠지는 것을 막는다.
 * core.Table 을 그대로 감싼다(프롭 동일). 사람이 바꾼 선택은 그대로 따르고, 상위가 selectedRowKeys 를 주면(업로드 뒤 전체 선택) 그 값에 더해 onChange 로 올린다.
 * 고친 행 = 받은 dataSource 와도 직전 onRowsChange 와도 다른 행(편집을 dataSource 에 되먹이지 않는 배선에서 사람이 푼 체크가 되살아나지 않게).
 * 행 수가 바뀐 변경(삭제 열)은 편집이 아니라 건너뛴다. 선택은 스코프 key(선택 epoch)가 바뀌어 다시 마운트될 때 비워진다.
 * editGate(표 dev.editRules): 고친 결과가 규칙에 걸리면 반영·자동 체크를 멈추고 확인창을 연다. [확인] 뒤 가드가 apply 로 돌아와 정상 통로를 탄다.
 * 연쇄 편집: 배선이 onRowsChange 에서 다른 행까지 바꿔 되먹이면(예: 상위 메뉴 허용여부 N → 하위 행 전파) 그 행도 체크에 더한다 —
 *  편집 직전 dataSource 와 그 뒤 처음 되먹인 dataSource 를 견줘 값이 바뀐 행(1.0 MA03 전파 행 setSelected(true) 미러).
 *  되먹임 확인 = 사람이 고친 행이 새 dataSource 에서 DS 가 돌려준 값과 같다(되먹이지 않는 배선의 재조회를 연쇄로 오인하지 않게).
 */
function EditSelTable<T extends Record<string, unknown>>({ rowSelection, onRowsChange, dataSource, editGate, ...rest }: Parameters<typeof core.Table<T>>[0] & { editGate?: (prev: readonly T[], next: T[], apply: (rows: T[]) => void) => boolean }) {
  const [inner, setInner] = useState<React.Key[]>([])
  const keys = rowSelection?.selectedRowKeys ?? inner
  // 미뤄 둔 반영이 견줄 최신 선택 — 편집 시점의 keys 로 합치면 그 사이 사람이 바꾼 체크를 덮는다(데모 setKeys((cur) => …) 와 같은 결과).
  const cur = useRef(keys)
  cur.current = keys
  const last = useRef<T[] | null>(null)
  const keyField = typeof rest.rowKey === 'string' ? rest.rowKey : 'key'
  const keyOf = (r: T, i: number): React.Key => (r[keyField] as React.Key | undefined) ?? i
  const same = (a: T, b: T) => a === b || Array.from(new Set([...Object.keys(a), ...Object.keys(b)])).every((k) => Object.is(a[k], b[k]))
  const index = (rs: readonly T[]) => new Map(rs.map((r, i) => [String(keyOf(r, i)), r]))
  const edited = (next: T[]): React.Key[] => {
    const source = dataSource ?? []
    if (next.length !== source.length) return []
    const src = index(source)
    const prev = last.current && last.current.length === next.length ? index(last.current) : null
    return next.flatMap((r, i) => {
      const k = keyOf(r, i)
      const a = src.get(String(k))
      if (!a || same(a, r)) return []
      const b = prev?.get(String(k))
      return b && same(b, r) ? [] : [k]
    })
  }
  /** 체크에 더한다 — 이미 체크된 키는 건너뛰고, 더할 게 있으면 상위 onChange 로 올린다. */
  const addSel = (added: React.Key[], rows: readonly T[]) => {
    const have = new Set(cur.current.map(String))
    const extra = added.filter((k) => !have.has(String(k)))
    if (!extra.length) return
    const merged = [...cur.current, ...extra]
    const set = new Set(merged.map(String))
    cur.current = merged
    setInner(merged)
    rowSelection?.onChange?.(merged, rows.filter((r, i) => set.has(String(keyOf(r, i)))), { type: 'multiple' })
  }
  // 연쇄 편집 대기 — onRowsChange 때 편집 직전 dataSource·DS 가 돌려준 행을 잡아 두고, 배선이 되먹인 첫 dataSource 에서 바뀐 행을 체크에 더한다.
  const cascade = useRef<{ base: readonly T[]; next: readonly T[] } | null>(null)
  useEffect(() => {
    const p = cascade.current
    if (!p) return
    const source = dataSource ?? []
    if (source.length !== p.base.length) {
      cascade.current = null // 행 수가 바뀌었다(재조회·추가) — 연쇄가 아니다
      return
    }
    const base = index(p.base)
    const changed = source.flatMap((r, i) => {
      const k = keyOf(r, i)
      const b = base.get(String(k))
      return b && !same(b, r) ? [k] : []
    })
    if (!changed.length) return // 아직 되먹임 전(DS 갱신과 배선 갱신이 다른 커밋일 수 있다)
    cascade.current = null
    const src = index(source)
    const fed = p.next.every((r, i) => {
      const k = String(keyOf(r, i))
      const b = base.get(k)
      if (!b || same(b, r)) return true
      const s = src.get(k)
      return !!s && same(s, r)
    })
    if (fed) addSel(changed, source)
  })
  /** 정상 통로 — 바뀐 행을 찾아 두고, 상위에 알리고, 그 행을 체크에 더한다. 편집 규칙 [확인] 뒤에도 이 통로로 돌아온다. */
  const commit = (next: T[]) => {
    const added = edited(next)
    last.current = next
    if (next.length === (dataSource ?? []).length) cascade.current = { base: dataSource ?? [], next }
    onRowsChange?.(next)
    if (!added.length) return
    // DS 표는 onRowsChange 를 자기 상태 갱신 함수 안에서 부른다 — 곧장 이 컴포넌트를 갱신하면 렌더 중 갱신 경고라 한 박자 미룬다.
    queueMicrotask(() => addSel(added, next))
  }
  return (
    <core.Table<T>
      {...rest}
      dataSource={dataSource}
      rowSelection={rowSelection && {
        ...rowSelection,
        selectedRowKeys: keys,
        onChange: (k, rows, info) => {
          setInner(k)
          cur.current = k
          rowSelection.onChange?.(k, rows, info)
        },
      }}
      onRowsChange={(next) => {
        // 편집 규칙(표 dev.editRules) — 걸리면 **반영도 자동 체크도 하지 않는다**(되돌림 + 확인창은 가드가 한다).
        //  [확인] 뒤에는 가드가 apply 로 돌아와 아래 정상 통로를 그대로 탄다 — 그때 바뀐 행만 체크에 더해진다.
        if (editGate && editGate(dataSource ?? [], next, commit)) return
        commit(next)
      }}
    />
  )
}

/** 표 카운트 — 같은 core.TableSelectionScope 안 표의 선택 개수를 '선택 N / 전체' 로 함께 그린다(데모 TableStatRender 와 같은 규약). 스코프 밖이면 전체만. */
function SelStat(props: ComponentProps<typeof core.TableStat>) {
  const n = core.useTableSelectionCount()
  return <core.TableStat {...props} selectedCount={n && n > 0 ? n : undefined} />
}

/**
 * 선택 행 브리지(문서 50 슬롯 2차) — 같은 core.TableSelectionScope 안 표의 선택 행을 모듈 변수 selRef 로 흘려 보낸다.
 * 액션 슬롯이 ctx.selected 로 받고, 배선이 wiring.onSelect 로 같은 값을 구독한다(상세 표가 선택을 따라가는 화면).
 *
 * 한 화면에 스코프가 여럿이면(위아래 표) **선택이 있는 스코프만** selRef 를 쓴다 — 선택 표가 없는 스코프가
 * 빈 배열로 덮으면 다른 표의 선택이 사라진다(2026-09-19 gl11 위아래 표에서 발견).
 *
 * scope = 이 스코프를 연 그룹 노드 id. 선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지
 * 알 수 없다 — 배선이 위아래를 갈라 두려면 이 값이 있어야 한다(2026-09-21 est01).
 */
function SelBridge({ scope }: { scope: string }) {
  const s = core.useTableSelection()
  const rows = s?.rows
  const owned = useRef(false)
  useEffect(() => {
    if (rows?.length) {
      owned.current = true
      selRef.current = rows
      wiring.onSelect?.(rows, scope)
    } else if (owned.current) {
      owned.current = false
      selRef.current = []
      wiring.onSelect?.([], scope)
    }
    return () => { // 언마운트·스코프 이탈 때 비운다(모듈 변수라 다음 인스턴스로 새지 않게, #772 봇)
      if (!owned.current) return
      owned.current = false
      selRef.current = []
    }
  }, [rows, scope]) // scope 는 그룹 id 리터럴이라 실제로 안 바뀌지만 exhaustive-deps 규칙상 넣는다(moms-fe #787 봇)
  return null
}

// 표 슬롯 미지정 기본값 — 데모 목데이터를 그대로 그린다(wiring.rows 를 안 주거나 그 표만 비웠을 때).
const keepDemoRows = (demo: Row[]): Row[] => demo
export default function PairOrderSchedulePage() {
  const hdrma19Title_titleRowDef = usePageHeaderSticky()
  // 조회영역 값 버스(그룹 #ma19FilterCard) — 각 필드가 filterKey(없으면 노드 id)를 키로 값을 올린다. [초기화]는 기본값으로 되돌리고 토큰을 올려
  //  모든 필드를 기본값으로 되돌린다(DS resetToken 계약). [조회]는 이 객체를 그대로 쿼리 조건으로 쓴다.
  const flMa19FilterCardDefaults = useMemo(() => (wiring.filterDefaults?.ma19FilterCard ?? ((d: Record<string, unknown>) => d))(flMa19FilterCardDefaults_DEMO), []) // 조회 조건 기본값 — wiring.filterDefaults 슬롯(동기). [초기화] 가 돌아가는 값
  const flMa19FilterCardDefaultsInitial = useMemo(() => (wiring.filterInitial?.ma19FilterCard ?? ((d: Record<string, unknown>) => d))(flMa19FilterCardDefaults), [flMa19FilterCardDefaults]) // 진입 초기값 — wiring.filterInitial 슬롯(동기, 예: URL 복원). 없으면 기본값
  const [flMa19FilterCard, setFlMa19FilterCard] = useState<Record<string, unknown>>(flMa19FilterCardDefaultsInitial)
  const [flMa19FilterCardReset, setFlMa19FilterCardReset] = useState(0)
  // 조회영역 접기(그룹 #ma19FilterCard) — 닫히면 필드가 값 칩으로 바뀌고 [필터 열기] 로 되돌린다(규격 CSS .pbo-filter-collapse-*).
  const [flMa19FilterCardCollapsed, setFlMa19FilterCardCollapsed] = useState(false)
  const [stSelEpoch, setStSelEpoch] = useState(0) // 토글 상태(스토어 키 'selEpoch')
  const selResetToken = wiring.selResetToken // 배선이 표를 새로 깔면 선택을 비운다(wiring.selResetToken)
  const selResetFirst = useRef(true)
  useEffect(() => { if (selResetFirst.current) { selResetFirst.current = false; return } setStSelEpoch((n) => n + 1) }, [selResetToken])
  useEffect(() => { // 옵션이 늦게 도착한 뒤 비어 있는 조회 조건을 채운다 — wiring.filterFallback 슬롯(값이 있는 키는 덮지 않는다)
    if (!wiring.filterFallback?.ma19FilterCard) return
    setFlMa19FilterCard((s) => { const patch = wiring.filterFallback?.ma19FilterCard?.(s, {  }); if (!patch) return s; let n = s; Object.entries(patch).forEach(([k, v]) => { const c = s[k]; if (c === undefined || c === '' || (Array.isArray(c) && c.length === 0)) { if (n === s) n = { ...s }; n[k] = v } }); return n })
  }, [flMa19FilterCardReset])
  // 페이저 ↔ 표 짝(pagerKey 'pager') — 액션바 페이저가 페이지를 소유하고 표는 그 페이지만 그린다. '몇 개씩' 미노출 = 10,000개씩(MOMS·MWMS 공통 규칙 2026-08-24).
  const [pgPager, setPgPager] = useState(() => ({ page: wiring.stateInitial?.pager?.pager?.page ?? 1, size: wiring.stateInitial?.pager?.pager?.size ?? 10000 })) // 진입 초기값 = wiring.stateInitial(예: URL 복원)
  const [stListq_table_q, setStListq_table_q] = useState(wiring.stateInitial?.listq?.["table.q"] ?? '') // 토글 상태(스토어 키 'listq:table.q')
  const [stModal_ma19UploadModal, setStModal_ma19UploadModal] = useState(false) // 토글 상태(스토어 키 'modal:ma19UploadModal')
  const [stModal_ma19DownloadModal, setStModal_ma19DownloadModal] = useState(false) // 토글 상태(스토어 키 'modal:ma19DownloadModal')
  const ROWS_IS_CURRENT_OPTIONS = wiring.options?.ROWS_IS_CURRENT ? wiring.options.ROWS_IS_CURRENT(ROWS_IS_CURRENT_OPTIONS_DEMO) : ROWS_IS_CURRENT_OPTIONS_DEMO // 편집 셀 옵션 — wiring.options 슬롯(훅 가능)
  const COLUMNS: core.CoreColumnType[] = [{"title":"화주코드","dataIndex":"SPR_NM","width":140,"required":true,"variant":"input"},{"title":"결제일","dataIndex":"CLS_DATE","width":120,"required":true,"variant":"input"},{"title":"차수","dataIndex":"CUT_SEQ","width":80,"align":"right","variant":"input"},{"title":"마감시각","dataIndex":"CUT_OFF_TIME","width":100,"variant":"input"},{"title":"잔여출고확정","dataIndex":"IS_CURRENT","width":130,"variant":"select","variantProps":{"options":ROWS_IS_CURRENT_OPTIONS}},{"title":"출고예정일","dataIndex":"FST_GI_END","width":120,"variant":"input"},{"title":"최종출고일","dataIndex":"LST_GI_END","width":120,"variant":"input"},{"title":"생성일자","dataIndex":"INS_DATE","width":150},{"title":"생성자","dataIndex":"INS_BY","width":200},{"title":"수정일자","dataIndex":"UPD_DATE","width":150},{"title":"수정자","dataIndex":"UPD_BY","width":200}]
  const ROWS_R = (wiring.rows?.ROWS ?? keepDemoRows)(ROWS_DEMO, { filters: flMa19FilterCard, pager: pgPager }) // 표 데이터 — wiring.ts 슬롯(인자 = 데모 목데이터·조회 조건(모달 표는 모달 [조회] 적용 조건)·페이저)
  const ROWS = Array.isArray(ROWS_R) ? ROWS_R : ROWS_R.rows
  const ROWS_TOTAL = Array.isArray(ROWS_R) ? ROWS.length : (ROWS_R.total ?? ROWS.length)
  const COLUMNS_FN = wiring.columns?.ma19Table // 컬럼 가공(플래그·열 추가) — wiring.columns 슬롯. 배치는 columnLayout
  const COLUMNS_W = COLUMNS_FN ? COLUMNS_FN(COLUMNS) : COLUMNS // 컬럼 상수가 본문(셀 모달·옵션 슬롯 참조)이라 매 렌더 새 배열 — 메모 대상이 아니다
  const ROWS_CL = wiring.columnLayout?.ma19Table?.(COLUMNS_W) // 컬럼 배치(순서·너비·고정·숨김) — 없으면 표 내부 상태
  // [목록 검색] 표시 컬럼 전체 부분일치(대소문자 무시) — 어댑터 TableRender listQ 규약. 확정은 검색칸 엔터/돋보기(onSearch).
  const ROWSListed = useMemo(() => {
    const q = stListq_table_q.trim().toLowerCase()
    if (!q) return ROWS
    const idx = COLUMNS.map((c) => c.dataIndex).filter((d): d is string => typeof d === 'string')
    const hit = (x: Record<string, unknown>) => idx.some((di) => String((x[di] ?? '') as string | number).toLowerCase().includes(q))
    return ROWS.flatMap((r) => {
      const kids = Array.isArray(r.children) ? (r.children as Record<string, unknown>[]) : undefined
      if (kids) { const kept = kids.filter(hit); if (kept.length) return [{ ...r, children: kept }]; return hit(r) ? [{ ...r, children: [] }] : [] }
      return hit(r) ? [r] : []
    })
  }, [stListq_table_q, ROWS])
  visRef.current = ROWSListed // 액션 슬롯 ctx.visible — 목록 검색 뒤 보이는 행
  const ROWS_SERVERPAGED = !Array.isArray(ROWS_R) && ROWS_R.total != null // total 을 준 쪽이 서버 페이징
  const ROWS_PG = ROWS_SERVERPAGED ? pgPager.page : Math.min(pgPager.page, Math.max(1, Math.ceil(ROWSListed.length / pgPager.size))) // 건수가 줄어 지금 페이지가 범위를 넘으면 마지막 페이지를 그린다(옛 손코드 pageNo clamp — 목록 검색·업로드·삭제 뒤 빈 표 방지). 페이저 표시·onState 도 이 값(상태는 그대로 — 복원한 페이지를 로딩 중 0건으로 잃지 않는다)
  const ROWS_PAGE = ROWS_SERVERPAGED ? ROWSListed : ROWSListed.slice((ROWS_PG - 1) * pgPager.size, ROWS_PG * pgPager.size)
  // [+ 추가] 한 행을 체크 선택에 더한다 — 저장이 고른 행만 보내는 화면에서 새 행 체크를 잊어 저장에서 빠지는 것을 막는다(편집 시 자동 체크와 같은 취지).
  //  누르기 직전 행 키를 남겨 두고, 슬롯이 행을 넣은 뒤 새로 생긴 키(이 페이지에 보이는 것)를 선택에 더한다. 선택은 업로드 뒤 전체 선택과 같은 stSelAll 로 제어한다.
  const addSnap_ROWS = useRef<Set<string> | null>(null)
  const [stAddTick_ROWS, setStAddTick_ROWS] = useState(0)
  useEffect(() => {
    const before = addSnap_ROWS.current
    if (!before) return
    addSnap_ROWS.current = null
    const pageKeys = ROWS_PAGE.map((r, i) => (r.id as React.Key | undefined) ?? i)
    const added = pageKeys.filter((k) => !before.has(String(k)))
    if (!added.length) return
    setStSelAll((cur) => {
      const base = cur === 'all' ? pageKeys : cur ?? selRef.current.map((r) => r.id as React.Key)
      return [...base, ...added.filter((k) => !base.includes(k))]
    })
  }, [stAddTick_ROWS]) // eslint-disable-line react-hooks/exhaustive-deps -- 추가 직후 한 번만(ROWS_PAGE 는 그 렌더의 값)
  const [unsavedEdits_ma19Table, setUnsavedEdits_ma19Table] = useState<Record<string, unknown>[] | null>(null) // 미저장 이탈 경고 — 표가 올린 편집 행
  const [unsavedEpoch_ma19Table, setUnsavedEpoch_ma19Table] = useState(0) // 되돌리기 = 표 재마운트
  const [unsavedSaved_ma19Table, setUnsavedSaved_ma19Table] = useState<Record<string, Record<string, unknown>>>({}) // [저장] 성공으로 확정한 행(키 → 행) — 조회 결과 위에 얹는 기준선
  const unsavedCount_ma19Table = unsavedEdits_ma19Table ? unsavedEdits_ma19Table.filter((r) => { const b = unsavedSaved_ma19Table[String(r.id ?? '')] ?? ROWS.find((o) => (o as Record<string, unknown>).id === r.id); return !!b && JSON.stringify(b) !== JSON.stringify(r) }).length : 0
  useEffect(() => { setUnsavedEdits_ma19Table(null); setUnsavedSaved_ma19Table({}) }, [ROWS]) // 저장본(조회 결과)이 바뀌면 기준선을 새로
  useEffect(() => { unsavedSave_ma19Table.pick = (sel) => sel.map((r) => ({ ...((unsavedEdits_ma19Table ?? []).find((e) => String(e.id ?? '') === String(r.id ?? '')) ?? r) })); unsavedSave_ma19Table.commit = (rows) => setUnsavedSaved_ma19Table((m) => ({ ...m, ...Object.fromEntries(rows.map((r) => [String(r.id ?? ''), r])) })); return () => { unsavedSave_ma19Table.pick = () => []; unsavedSave_ma19Table.commit = () => {} } }) // [저장] 확인 — 요청 시점 값만 기준선으로 확정(체크 안 한 수정분은 남는다) · 언마운트 때 비운다
  useEffect(() => { setTableUnsaved("ma19Table", unsavedCount_ma19Table, () => { setUnsavedEdits_ma19Table(null); setUnsavedEpoch_ma19Table((n) => n + 1) }) }, [unsavedCount_ma19Table])
  useEffect(() => () => clearTableUnsaved("ma19Table"), [])
  const reqMiss_ma19Table = (sel?: Row[]): number => { const keys = sel ? new Set(sel.map((r) => String((r.id as string | number | undefined) ?? ''))) : null; return (unsavedEdits_ma19Table ?? ROWS).filter((r) => !keys || keys.has(String((r.id as string | number | undefined) ?? ''))).filter((r) => ["SPR_NM","CLS_DATE"].some((di) => { const v = r[di]; return v == null || (typeof v === 'string' && v.trim() === '') })).length } // 필수 미입력 행 수(체크 행) — [저장] requiredGuard
  const REASONRADIO_OPTIONS = wiring.options?.REASONRADIO_OPTIONS ? wiring.options.REASONRADIO_OPTIONS(REASONRADIO_OPTIONS_DEMO) : REASONRADIO_OPTIONS_DEMO // 옵션 — wiring.options 슬롯
  const [fs_ma19DownloadModal, setFs_ma19DownloadModal] = useState<FormState>({}) // 폼 버스 'ma19DownloadModal' — 입력이 발행한 값
  const fsx_ma19DownloadModal: FormState = wiring.form?.ma19DownloadModal ? wiring.form.ma19DownloadModal(fs_ma19DownloadModal) : fs_ma19DownloadModal // 유효 상태(wiring.form 이 파생 필드를 덮어쓴다)
  const fset_ma19DownloadModal = (field: string, v: unknown) => setFs_ma19DownloadModal((s) => ({ ...s, [field]: v }))
  useEffect(() => { // 열 때 폼 버스의 openResetFields 를 비운다(입력 DOM 은 destroyOnClose 로 새로 마운트)
    if (stModal_ma19DownloadModal) setFs_ma19DownloadModal((s) => { const n = { ...s }; ["reason","detail"].forEach((f) => { delete n[f] }); return n })
  }, [stModal_ma19DownloadModal])
  const [fs_ma19UploadModal, setFs_ma19UploadModal] = useState<FormState>({}) // 폼 버스 'ma19UploadModal' — 입력이 발행한 값
  const fsx_ma19UploadModal: FormState = wiring.form?.ma19UploadModal ? wiring.form.ma19UploadModal(fs_ma19UploadModal) : fs_ma19UploadModal // 유효 상태(wiring.form 이 파생 필드를 덮어쓴다)
  const fset_ma19UploadModal = (field: string, v: unknown) => setFs_ma19UploadModal((s) => ({ ...s, [field]: v }))
  useEffect(() => { // 열 때 폼 버스의 openResetFields 를 비운다(입력 DOM 은 destroyOnClose 로 새로 마운트)
    if (stModal_ma19UploadModal) setFs_ma19UploadModal((s) => { const n = { ...s }; ["file","files"].forEach((f) => { delete n[f] }); return n })
  }, [stModal_ma19UploadModal])
  useEffect(() => {
    document.body.classList.add('pbo-screen-portal')
    const hadFontsPortals = document.body.classList.contains('pbo-fonts-portals')
    if (!hadFontsPortals) document.body.classList.add('pbo-fonts-portals')
    return () => { document.body.classList.remove('pbo-screen-portal'); if (!hadFontsPortals) document.body.classList.remove('pbo-fonts-portals') }
  }, [])
  const [stSelAll, setStSelAll] = useState<'all' | React.Key[] | null>(null) // 업로드 뒤 전체 선택(wiring.selectAllAfterUpload) — null = 표 내부 선택 · 선택을 비우는 자리(조회·초기화·액션 성공)에서 null 로 돌아간다
  useEffect(() => { selReset.current = () => { setStSelEpoch((n) => n + 1); setStSelAll(null); }; return () => { selReset.current = () => {} } }, []) // 확인창 성공 뒤 선택·마스터 pick 비움
  useEffect(() => { wiring.onState?.({ pager: { "pager": { ...pgPager, page: ROWS_PG } }, listq: { "table.q": stListq_table_q } }) }, [pgPager, ROWS_PG, stListq_table_q]) // 화면 상태 → 배선(URL/세션 persist)
  useEffect(() => { wiring.onModal?.({ "ma19UploadModal": stModal_ma19UploadModal, "ma19DownloadModal": stModal_ma19DownloadModal }) }, [stModal_ma19UploadModal, stModal_ma19DownloadModal]) // 모달 열림 → 배선(후보 조회 게이트)
  useEffect(() => { origRows.set("ROWS", ROWS); return () => { origRows.delete("ROWS") } }, [ROWS]) // 문구 토큰의 원본 행(fillTok)
  return (
    <core.ConfigProvider theme={pboLogisticsTheme} renderEmpty={renderPboEmpty}>
      <div className="pbo-core-screen pbo-screen-shell pbo-fonts">
        {/* #pairOrderSchedule PairOrderSchedulePage */}
        <core.Flex vertical gap={16} align="stretch">
          {/* #workspaceTab WorkspaceTab */}
          <core.WorkspaceTab style={{ margin: "-24px -24px 0px -24px" }} activeLabel="합배송스케쥴" />
          {/* ▼ 그룹 cmp.TitleRow #ma19Title — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #ma19Title:titleRowDef TitleRow */}
          <core.Flex gap={8} justify="space-between" align="center" ref={hdrma19Title_titleRowDef.ref} className={`dev-page-header-wrap pin${hdrma19Title_titleRowDef.isSticky ? ' sticky' : ''}`} style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 'auto', minHeight: 40, top: 'calc(12px - var(--pbo-page-header-scroller-pad, 0px))', ['--pbo-page-header-bleed-top' as string]: '36px' }}>
            {/* #ma19Title:pageTitle PageTitle */}
            <core.Typography.Title level={4} style={{ margin: 0, whiteSpace: 'pre-line' }}>합배송스케쥴</core.Typography.Title>
            {/* #ma19Title:titleRight TitleRight */}
            <core.Flex gap={16} align="center">{null}</core.Flex>
          </core.Flex>
          {/* ▲ 그룹 cmp.TitleRow #ma19Title 끝 */}
          {/* ▼ 그룹 cmp.FilterCard #ma19FilterCard — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #ma19FilterCard:filterCardDef FilterCard */}
          <core.Card styles={{ body: { padding: "12px 20px" } }} style={{ border: '1px solid #d9d9d9', borderRadius: 8, minWidth: 0 }}>
            <div className="pbo-filter-collapse-open">
              {/* #ma19FilterCard:filterBody FilterBody */}
              <div className={`${flMa19FilterCardCollapsed ? 'pbo-filter-collapse-closed' : 'pbo-filter-collapse-open'}`}>
                {flMa19FilterCardCollapsed && <span className="pbo-filter-empty-msg">필터가 적용된 항목이 없어요. 필터를 열어 원하는 조건으로 검색해 보세요.</span>}
                {/* #ma19FilterCard:filterFields FilterFields */}
                <core.Flex gap={20} align="flex-start" wrap>
                  {/* ▼ 그룹 cmp.FilterField #ma19ClsDate — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                  {/* #ma19ClsDate:filterFieldDef FilterField */}
                  <FilterField collapsed={flMa19FilterCardCollapsed} label="결제일" required={wiring.filterRequired?.["ma19ClsDate:filterFieldDef"] ?? true} chip={chipRange(flMa19FilterCard.CLS_DATE ?? presetRange("today", "futureTo"))} fieldKey="ma19ClsDate:filterFieldDef" onOpen={() => setFlMa19FilterCardCollapsed(false)}>
                    {/* #ma19ClsDate:control Control */}
                    <DateRangeField key={flMa19FilterCardReset} value={flMa19FilterCard.CLS_DATE as [string, string] | undefined} onChange={(v) => setFlMa19FilterCard((s) => ({ ...s, CLS_DATE: v }))} defaultPeriod="today" />
                  </FilterField>
                  {/* ▲ 그룹 cmp.FilterField #ma19ClsDate 끝 */}
                </core.Flex>
                {/* #ma19FilterCard:filterFooter FilterFooter */}
                <core.Flex gap={8} justify="flex-end" align="center">
                  {/* #ma19FilterCard:filterToggleButton FilterToggleButton */}
                  <core.Button icon={flMa19FilterCardCollapsed ? <DownOutlined /> : <UpOutlined />} onClick={() => setFlMa19FilterCardCollapsed((x) => !x)}>{`필터 ${flMa19FilterCardCollapsed ? '열기' : '닫기'}`}</core.Button>
                  {/* #ma19FilterCard:filterFooterDivider FilterFooterDivider */}
                  <span style={{ height: 18, margin: '0 0px', borderLeft: "1px solid #d9d9d9", display: 'block', flex: 'none' }} />
                  {/* #ma19FilterCard:resetButton ResetButton */}
                  {permCan('CLEAR') && <core.Button onClick={() => { const go = () => { setFlMa19FilterCard((wiring.filterDefaults?.ma19FilterCard ?? ((d: Record<string, unknown>) => d))(flMa19FilterCardDefaults_DEMO)); setFlMa19FilterCardReset((t) => t + 1); wiring.onReset?.() }; const ok = wiring.canReset?.(); if (ok instanceof Promise) { ok.then((r) => { if (r !== false) go() }, () => undefined); return } if (ok !== false) go() }}>초기화</core.Button>}
                  {/* #ma19FilterCard:searchButton SearchButton */}
                  {permCan('SEARCH') && <core.Button type="primary" onClick={() => { confirmDiscardUnsaved(() => { Promise.resolve(wiring.actions?.search?.(flMa19FilterCard)).then((r) => { if (r === false) { return } setPgPager((s) => (s.page === 1 ? s : { ...s, page: 1 })); setStSelEpoch((n) => n + 1); setStSelAll(null); setStListq_table_q(''); }, reportActionError("search")) }, 'refresh') }}>조회</core.Button>}
                </core.Flex>
              </div>
            </div>
          </core.Card>
          {/* ▲ 그룹 cmp.FilterCard #ma19FilterCard 끝 */}
          {/* ▼ 그룹 cmp.TableGroup #tableGroup — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #tableGroup:tableGroupDef TableGroup */}
          <core.TableSelectionScope key={stSelEpoch}><SelBridge scope="tableGroup" />
            {/* #tableGroup:tableGroupInner TableGroupInner */}
            <core.Flex vertical gap={8} align="stretch">
              {wiring.feedback?.tableGroup}
              {/* #tableGroup:tableHeader TableHeader */}
              <core.Flex style={{ padding: "4px 0px 4px 0px" }} gap={8} justify="space-between" align="center" className="pbo-v2-actionbar-sticky">
                {/* #tableGroup:toolbarLeft ToolbarLeft */}
                <core.Space>
                  {/* #ma19TableStat TableStat */}
                  <SelStat totalLabel={wiring.tableText?.tableGroup?.totalLabel} total={ROWS_TOTAL} />
                  {/* #ma19SaveButton SaveButton */}
                  {permCan('SAVE') && <SelGatedButton type="primary" onClick={() => { if (wiring.opens?.ma19SaveButton?.(selCtx()) === false) { return } if (reqMiss_ma19Table(selCtx().selected) > 0) { confirmma19RequiredNotice(); return } confirmma19SaveConfirm() }}>저장</SelGatedButton>}
                  {/* #ma19DeleteButton DeleteButton */}
                  {permTool('remove') && <SelGatedButton onClick={() => { if (wiring.opens?.ma19DeleteButton?.(selCtx()) === false) { return } confirmma19DeleteConfirm() }}>삭제</SelGatedButton>}
                </core.Space>
                {/* #tableGroup:toolbarRight ToolbarRight */}
                <core.Space>
                  {/* #tableGroup:tablePager TablePager */}
                  <core.TablePager variant="paged" page={ROWS_PG} pageSize={pgPager.size} total={(stListq_table_q.trim() ? ROWSListed.length : ROWS_TOTAL)} showSizeChanger={false} onPage={(page, size) => { const go = () => { setStSelEpoch((n) => n + 1); setStSelAll(null); setPgPager({ page: size === pgPager.size ? page : 1, size }) }; const ok = wiring.canChangePage?.({ pager: "pager", page, size }); if (ok instanceof Promise) { ok.then((r) => { if (r !== false) go() }, reportActionError("canChangePage")); return } if (ok !== false) go() }} />
                  {/* #tableGroup:listSearch ListSearch */}
                  <core.Input.Search placeholder="목록 검색" allowClear key={stSelEpoch} style={{ width: '100%', maxWidth: 240, minWidth: 240 }} defaultValue={stListq_table_q} onSearch={(v) => setStListq_table_q((v ?? '').trim())} />
                  {/* #tableGroup:toolbarDivider2 Divider */}
                  <span style={{ height: 18, margin: '0 4px', borderLeft: "1px solid #d9d9d9", display: 'block', flex: 'none' }} />
                  {/* #ma19AddButton AddButton */}
                  {permTool('add') && <core.Button icon={<DsIcon name="ic-plus" size={16} color="currentColor" />} onClick={() => { addSnap_ROWS.current = new Set(ROWS.map((r, i) => String((r.id as React.Key | undefined) ?? i))); Promise.resolve(wiring.actions?.ma19AddButton?.({ ...selCtx(), table: "ROWS", defaults: {} })).then(() => { setStAddTick_ROWS((n) => n + 1) }, (e: unknown) => { addSnap_ROWS.current = null ; reportActionError("ma19AddButton")(e) }) }}>추가</core.Button>}
                  {/* #ma19UploadButton UploadButton */}
                  {permTool('upload') && <core.Button icon={<DsIcon name="ic-upload" size={16} color="currentColor" />} onClick={() => { if (wiring.opens?.ma19UploadButton?.(selCtx()) === false) { return } setStModal_ma19UploadModal(true) }}>엑셀 업로드</core.Button>}
                  {/* #ma19ExcelButton ExcelButton */}
                  {permTool('download') && <core.Button icon={<DsIcon name="ic-download" size={16} color="currentColor" />} onClick={() => { if (wiring.opens?.ma19ExcelButton?.(selCtx()) === false) { return } setStModal_ma19DownloadModal(true) }}>엑셀 다운로드</core.Button>}
                </core.Space>
              </core.Flex>
              {/* #ma19Table Table */}
              <EditSelTable columns={permCols(COLUMNS_W)} dataSource={ROWS_PAGE.map((r) => unsavedEdits_ma19Table?.find((e) => e.id === r.id) ?? unsavedSaved_ma19Table[String((r.id as string | number | undefined) ?? '')] ?? r)} rowKey="id" loading={Array.isArray(ROWS_R) ? undefined : ROWS_R.loading} locale={wiring.tableText?.tableGroup?.emptyText != null ? { emptyText: wiring.tableText?.tableGroup?.emptyText } : undefined} rowSelection={{ type: "checkbox", columnWidth: 48, ...(stSelAll ? { selectedRowKeys: stSelAll === 'all' ? ROWS_PAGE.flatMap((r, i) => (typeof wiring.selectAllAfterUpload !== 'function' || wiring.selectAllAfterUpload(r) ? [(r.id as React.Key | undefined) ?? i] : [])) : stSelAll, onChange: (keys: React.Key[]) => setStSelAll(keys) } : {}) }} stickyOffset={104} size="middle" scroll={{ x: 'max-content' }} key={unsavedEpoch_ma19Table} onRowsChange={(next) => { setUnsavedEdits_ma19Table(next as Record<string, unknown>[]); wiring.actions?.ROWS_rowsChange?.(next as Record<string, unknown>[]) }} columnOrder={ROWS_CL?.columnOrder} onColumnOrderChange={ROWS_CL?.onColumnOrderChange} columnWidths={ROWS_CL?.columnWidths} onColumnWidthsChange={ROWS_CL?.onColumnWidthsChange} pinnedColumns={ROWS_CL?.pinnedColumns} onPinnedColumnsChange={ROWS_CL?.onPinnedColumnsChange} hiddenColumns={ROWS_CL?.hiddenColumns} onHiddenColumnsChange={ROWS_CL?.onHiddenColumnsChange} />
            </core.Flex>
          </core.TableSelectionScope>
          {/* ▲ 그룹 cmp.TableGroup #tableGroup 끝 */}
          {/* 컨펌 모달 confirmma19RequiredNotice() — opens=ma19RequiredNotice 인 버튼이 호출한다(codegen 배선). */}
          {/* 컨펌 모달 confirmma19SaveConfirm() — opens=ma19SaveConfirm 인 버튼이 호출한다(codegen 배선). */}
          {/* 컨펌 모달 confirmma19DeleteConfirm() — opens=ma19DeleteConfirm 인 버튼이 호출한다(codegen 배선). */}
          {/* #ma19DownloadModal DownloadModal */}
          <core.Modal destroyOnHidden /* openResetFields: reason, detail — 닫힐 때 버려 열 때 새 폼 */ open={stModal_ma19DownloadModal} onCancel={() => { setStModal_ma19DownloadModal(false) }} onOk={() => { Promise.resolve(wiring.actions?.ma19DownloadModal_ok?.({ ...selCtx(), form: fsx_ma19DownloadModal })).then((r) => { if (typeof r === 'string') core.message.success(r); setStModal_ma19DownloadModal(false) }, (e: unknown) => { if ((e as { closeModal?: boolean } | null)?.closeModal) setStModal_ma19DownloadModal(false) }) /* 실패 = 슬롯이 토스트·throw — 모달을 열어 둔다(던진 값에 closeModal: true 가 있으면 닫는다 — 옛 손코드가 닫고 나서 처리하던 실패). okClosesFirst 모달은 누르자마자 닫고 뒤에서 처리한다. onOk 타입은 () => void 라 async 를 직접 주지 않는다(#772 봇) */ }} okButtonProps={{ disabled: !(fsx_ma19DownloadModal.reason && ((typeof fsx_ma19DownloadModal.detail === 'string' ? fsx_ma19DownloadModal.detail : '').trim() !== '' && (typeof fsx_ma19DownloadModal.detail === 'string' ? fsx_ma19DownloadModal.detail : '').trim().length >= 5)) }} footer={withOkTip(!(fsx_ma19DownloadModal.reason && ((typeof fsx_ma19DownloadModal.detail === 'string' ? fsx_ma19DownloadModal.detail : '').trim() !== '' && (typeof fsx_ma19DownloadModal.detail === 'string' ? fsx_ma19DownloadModal.detail : '').trim().length >= 5)) ? "사유코드를 고르고 상세사유를 5글자 이상 입력해 주세요." : null)} title="엑셀 다운로드" width={520} okText="확인" cancelText="취소" className="pbo-screen-modal">
            {/* #ma19DownloadModal-form ReasonForm */}
            <core.Form layout="horizontal" className="pbo-v2-form">
              {/* #ma19DownloadModal-reason 사유코드Item */}
              <core.FormItem label="사유코드" required labelWidth={88}>
                {/* #ma19DownloadModal-reasonRadio ReasonRadio */}
                <core.Radio.Group value={fsx_ma19DownloadModal.reason} onChange={(e: { target: { value?: unknown } }) => fset_ma19DownloadModal("reason", e.target.value)} options={REASONRADIO_OPTIONS} />
              </core.FormItem>
              {/* #ma19DownloadModal-detail 상세사유Item */}
              <core.FormItem label="상세사유" required labelWidth={88}>
                {/* #ma19DownloadModal-detailInput DetailInput */}
                <core.Input value={fsx_ma19DownloadModal.detail == null ? '' : String(fsx_ma19DownloadModal.detail as string | number)} onChange={(e: { target: { value?: unknown } }) => fset_ma19DownloadModal("detail", e.target.value)} placeholder="사유를 입력하세요" style={{ width: "100%" }} />
                {/* #ma19DownloadModal-detailHelp Help */}
                <core.Typography.Text style={{ fontSize: 12 }} type="secondary">5글자 이상 입력해주세요.</core.Typography.Text>
              </core.FormItem>
            </core.Form>
          </core.Modal>
          {/* ▼ 그룹 cmp.UploadModal #ma19UploadModal — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #ma19UploadModal:uploadModalDef UploadModal */}
          <core.Modal destroyOnHidden /* openResetFields: file, files — 닫힐 때 버려 열 때 새 폼 */ open={stModal_ma19UploadModal} onCancel={() => { setStModal_ma19UploadModal(false) }} onOk={() => { Promise.resolve(wiring.actions?.ma19UploadModal_ok?.({ ...selCtx(), form: fsx_ma19UploadModal })).then((r) => { if (typeof r === 'string') core.message.success(r); else if (r !== false) { core.message.success("업로드 완료"); } setStSelEpoch((n) => n + 1); setStSelAll(null); setStListq_table_q(''); if (wiring.selectAllAfterUpload) setStSelAll('all');  setStModal_ma19UploadModal(false) }, (e: unknown) => { if ((e as { closeModal?: boolean } | null)?.closeModal) setStModal_ma19UploadModal(false) }) /* 실패 = 슬롯이 토스트·throw — 모달을 열어 둔다(던진 값에 closeModal: true 가 있으면 닫는다 — 옛 손코드가 닫고 나서 처리하던 실패). okClosesFirst 모달은 누르자마자 닫고 뒤에서 처리한다. onOk 타입은 () => void 라 async 를 직접 주지 않는다(#772 봇) */ }} okButtonProps={{ disabled: !(fsx_ma19UploadModal.file) }} title="엑셀 업로드" width={560} okText="업로드" cancelText="취소" className="pbo-screen-modal">
            {/* #ma19UploadModal:upBody UploadBody */}
            <core.Flex vertical gap={12} align="stretch">
              {/* #ma19UploadModal:upGuide UploadGuide */}
              <core.Typography.Text style={{ color: "rgba(0,0,0,0.65)" }}>{renderMarked("양식을 내려받아 작성한 엑셀 파일을 업로드해 주세요.", "ma19UploadModal:upGuide")}</core.Typography.Text>
              {/* #ma19UploadModal:upDragger UploadDragger */}
              <core.Upload.Dragger beforeUpload={() => false} accept=".xlsx" maxCount={1} onChange={(info: { fileList: unknown[] }) => { const files = info.fileList.map((f) => (f as { originFileObj?: unknown })?.originFileObj ?? f); fset_ma19UploadModal('file', files[files.length - 1]); fset_ma19UploadModal('files', files) }} style={{ display: 'block' }}>
                <p style={{ margin: '32px 0', color: 'rgba(0,0,0,0.65)' }}>클릭하거나 파일을 끌어다 놓으세요</p>
              </core.Upload.Dragger>
            </core.Flex>
          </core.Modal>
          {/* ▲ 그룹 cmp.UploadModal #ma19UploadModal 끝 */}
        </core.Flex>
      </div>
    </core.ConfigProvider>
  )
}
